import * as React from 'react';
import { Loader } from '@progress/kendo-react-indicators';
import '@progress/kendo-theme-default/dist/all.css';
import './index.scss';
export default function Test1() {
    return (
        <div className='test1'>
            <Loader type="converging-spinner" size="large" />
        </div>
    );
}